import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { LogOut, FlaskConical, SlidersHorizontal, TrendingUp, Bot } from "lucide-react";
import { AppSwitcher } from "../components/AppSwitcher";
import { InstallButton } from "../components/InstallButton";
import BacktestView from "../emarsi/BacktestView";
import BotsView from "../emarsi/BotsView";
import StrategySettingsView from "../emarsi/StrategySettingsView";

const TABS = [
  { id: "bots", label: "Botlar (Testnet)", icon: Bot },
  { id: "backtest", label: "Backtest", icon: FlaskConical },
  { id: "strategy", label: "Strateji Ayarları", icon: SlidersHorizontal },
];

export const DISCLAIMER = "Bu uygulama yatırım tavsiyesi değildir. Kaldıraçlı işlemlerde yatırılan teminatın tamamı kaybedilebilir. Geçmiş performans gelecekteki sonucu garanti etmez.";

export default function EmaRsiApp() {
  const { logout } = useAuth();
  const [tab, setTab] = useState(() => {
    const t = new URLSearchParams(window.location.search).get("tab");
    return TABS.some((x) => x.id === t) ? t : "bots";
  });
  return (
    <div className="min-h-screen bg-[#0B0E17] pb-28 sm:pb-16" data-testid="emarsi-app">
      <header className="sticky top-0 z-50 backdrop-blur-md bg-[#0E1320]/90 border-b border-[#1E2738]">
        <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between gap-3 flex-wrap">
          <div className="flex items-center gap-2.5">
            <div className="h-9 w-9 rounded-lg bg-[#F59E0B]/15 border border-[#F59E0B]/30 flex items-center justify-center"><TrendingUp className="h-5 w-5 text-[#F59E0B]" /></div>
            <AppSwitcher current="emarsi" subtitle={<span className="text-[10px] text-[#64748B] flex items-center gap-1.5">USDⓈ-M Vadeli · EMA 9/21 + RSI 14 · <span data-testid="emarsi-phase-badge" className="text-[#F59E0B] font-bold">FAZ 2 — TESTNET İŞLEM</span></span>} />
          </div>
          <div className="flex items-center gap-3">
            <InstallButton />
            <button data-testid="logout-button" onClick={logout} className="flex items-center gap-1.5 text-[#64748B] hover:text-[#EF4444] text-xs font-semibold transition-colors"><LogOut className="h-4 w-4" /> <span className="hidden sm:inline">Çıkış</span></button>
          </div>
        </div>
        <div className="max-w-7xl mx-auto px-2 overflow-x-auto">
          <div className="flex gap-1 min-w-max">
            {TABS.map((t) => { const Icon = t.icon; const active = tab === t.id; return (
              <button key={t.id} data-testid={`emarsi-tab-${t.id}`} onClick={() => setTab(t.id)} className={`flex items-center gap-1.5 px-4 py-2.5 text-sm font-semibold border-b-2 transition-colors whitespace-nowrap ${active ? "border-[#F59E0B] text-[#F59E0B]" : "border-transparent text-[#64748B] hover:text-[#94A3B8]"}`}><Icon className="h-4 w-4" /> {t.label}</button>
            ); })}
          </div>
        </div>
      </header>
      <main className="max-w-7xl mx-auto px-4 sm:px-6 py-5 space-y-5">
        {tab === "bots" && <BotsView />}
        {tab === "backtest" && <BacktestView />}
        {tab === "strategy" && <StrategySettingsView />}
      </main>
      <footer data-testid="emarsi-disclaimer" className="fixed inset-x-0 bottom-0 z-40 bg-[#0E1320]/95 backdrop-blur-md border-t border-[#1E2738] px-4 py-2 text-[11px] text-[#94A3B8] text-center" style={{ paddingBottom: "max(8px, env(safe-area-inset-bottom))" }}>
        ⚠️ {DISCLAIMER}
      </footer>
    </div>
  );
}
